import CallJSS from "@/Core/Bridge/CallJSS";
import {confJson} from "@/app/config/confJson";
import {KitConst} from "@/Fwk/Kit/KitConst";
import Util from "@/Master/Util";
import KitAPI from "../KitAPI";
import AdjustMgr from "@/Fwk/AdjustMgr";
import UtilBrowser from "@/Master/UtilBrowser";
import KitPwa from "@/Master/PWA/KitPwa";
import {masterConst} from "@/Master/Const/MasterConst";
import SdkTrack from "../SdkTrack";
import DuMgr from "@/Fwk/SM/DuMgr";
import SdkMgr from "@/Fwk/SDK/SdkMgr";
import {JsonData} from "@/Fwk/Kit/JsonData";
import GoogleTrack from "@/Fwk/Kit/GoogleTrack";
import {json} from "node:stream/consumers";

export class WebPlatform implements IPlatform {

    constructor() {
        CallJSS.GameInit()
    }

    public GetCfg(): string {
        return JSON.stringify(confJson);
    }

    public GetDeviceIpAddress(): string {
        return "0";
    }

    public isVpnConnected(): boolean {
        return false;
    }

    public isWifiProxy(): boolean {
        return false;
    }

    public IsNetworkOk(): boolean {
        return navigator.onLine;
    }

    public GetNetworkType(): string {
        // @ts-ignore
        const connection = navigator.connection || (navigator as any).mozConnection || (navigator as any).webkitConnection;
        if (connection) {
            return connection.effectiveType || 'unknown';
        } else {
            return 'unknown';
        }
    }

    public GetTestConfig(): string {
        const isTest = this.IsTestProduct();
        const isLog = Util.isLog;
        const json = new JsonData();
        json.put("log", isLog);
        json.put("unitylog", isLog);
        json.put("testmode", isTest);
        json.put("adtest", isTest);
        json.put("test210", isTest);
        return json.toString()
    }

    public GetElapsedRealtime(): number {
        return KitAPI.GetNowMills();
    }

    public GetVersionName(): string {
        return confJson.h5_version_name
    }

    public GetVersionCode(): number {
        return confJson.h5_version_code
    }

    public GetGAID(): string {
        return AdjustMgr.getWebUUID;
    }

    public GetAppLabel(): string {
        return confJson.h5_app_name;
    }

    public GetPackageName(): string {
        return confJson.h5_package_name;
    }

    public GetCountryCode(): string {
        return UtilBrowser.getSystemCountry;
    }

    public GetLanguage(): string {
        return UtilBrowser.getLanguage;
    }

    public GetOsVersion(): string {
        return UtilBrowser.getOsVersion;
    }

    public GetOsBrand(): string {
        return UtilBrowser.getBrowserName;//获取浏览器类型
    }

    public GetOsModel(): string {
        return UtilBrowser.getBrowserName + "" + UtilBrowser.getBrowserVersion;//浏览器版本
    }

    public JumpSettingConnect(): boolean {
        return false;
    }

    public JumpToAppStore(): boolean {
        return false;
    }

    public JumpSamsungAppstore(): boolean {
        return false;
    }

    public IsOpenDevelopmentSetting(): boolean {
        return Util.isTestMode;
    }

    public IsOpenedUSBDebug(): boolean {
        return Util.isTestMode;
    }

    public GetMcc(): string {
        return "0";
    }

    public IsVirLoc(): boolean {
        return Util.isTestMode;
    }

    public GetSSID(): string {
        return "";
    }

    public GetMAC(): string {
        return "";
    }

    public GetIdfv(): string {
        return "";
    }

    public launchApp(strValue: string): boolean {
        return false;
    }

    public hasInstalled(strValue: string): boolean {
        return false;
    }


    public IsInstalledPWA(): boolean {
        return KitPwa.isInstalled || KitPwa.isPlayPwa;
    }

    public IsPWA(): boolean {
        return KitPwa.isPlayPwa;
    }

    public InstallPWA() {
        Util.sendMessageToParent({types: masterConst.OnInstallPwa, val: 0});
    }

    public IsDesktopWeb(): boolean {
        return UtilBrowser.isDesktop;
    }

    public IsIOSWeb(): boolean {
        return Util.isIOS || UtilBrowser.isSafari;
    }

    public IsAndroidWeb(): boolean {
        return Util.isAndroid;
    }

    public getInstaller(): string {
        return "";
    }

    public GetNotchScree(): number {
        return 0;
    }

    public FirebaseEvent(name: string) {

    }

    public GoogleGTMEvent(name: string, jsonStr: string) {
        let json = {};
        try {
            json = JSON.parse(jsonStr);
        }
        catch (e) {
        }
        GoogleTrack.pushGTMEvent(name, json);
    }

    public InitShuzilmSDK(appKey: string) {

    }

    public QuerySmID(action: (id: string) => void): void {
        const id = DuMgr.SMID;
        action(id);
    }

    public StoreClipboard(text: string) {

    }


    public isRoot(): boolean {
        return false;
    }

    public IsTestProduct(): boolean {
        return Util.isTestMode;
    }

    public isSimulator(): boolean {
        return false;
    }


    public Jump(key: string, strValue: string): boolean {
        if (key === KitConst.URL) {
            return true;
        }

        return false;
    }

    public InitForterSDK(forterId: string) {
    }

    public SetForterUserID(userId: string) {

    }

    public GetForterJSCode() {
        return "";
    }

}
